import { createFileRoute, Navigate } from "@tanstack/react-router";
import { IssuesBoard } from "#app/components/issues/issues-board";
import { useWorkflowId } from "#app/lib/hooks/use-workflow-id";
import { useViews } from "#app/lib/views/view-context";
import { routePath } from "#app/lib/hooks/use-app-navigate";

/** `/workflow/$workflowId/board` — the workflow Kanban, scoped to one workflow. */
function WorkflowBoardRoute() {
  const { workspace } = Route.useParams();
  const workflowId = useWorkflowId();
  const { activeViewGone } = useViews();
  if (!workflowId) return null;
  // A deleted view's URL outlives it — in a bookmark, another browser tab,
  // `preferences.defaultRoute`. Land on the workflow, which resolves
  // whichever view is the default now. Only a loaded, NON-EMPTY row can say
  // deleted: an empty row (a failed load, an unseeded scope) renders this
  // built-in's body as the floor, and while the row is in flight the body
  // renders rather than a spinner — the built-in almost always exists.
  if (activeViewGone) {
    return (
      <Navigate
        to={routePath(`/${workspace}/workflow/${workflowId}`)}
        replace
      />
    );
  }
  return <IssuesBoard scope={{ kind: "workflow", workflowId }} />;
}

export const Route = createFileRoute(
  "/(app)/$workspace/workflow/$workflowId/board",
)({
  component: WorkflowBoardRoute,
});
